import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class CommentSort extends Class {
  constructor(element) {
    super();
    this.element = $(element);
    this.comments = this.element
      .parents("#ajaxCommentsList")
      .find("#ajaxComments");
    this.url = this.comments.attr("data-url");
    this.setUpEvents();
  }

  setUpEvents() {
    var self = this;
    // checkVoteOptions();
    this.element.on("change", function(e) {
      self.fetch();
      self.displayMoreButton();
    });
  }

  fetch() {
    var value = this.element[0].value,
      self = this;
    $.ajax({
      url: this.url + value,
      success: function(html) {
        self.replaceComments(html);
      }
    });
  }

  displayMoreButton() {
    $(".loadMoreButtonWrapper").removeClass("hide");
  }

  replaceComments(html) {
    var comments = $("#ajaxComments");
    comments.replaceWith($(html).find("#ajaxComments"));
    $("#comments")
      .find("[data-load-more-button-wrapper]")
      .removeClass("hide");
    $(window).trigger("abacus:loadcomments:complete", self.comments);
    $(window).trigger(
      "abacus:loadcomments:complete:datestimezone",
      self.comments
    );
    $(window).trigger("abacus:loadcomments:reloaded",self.comments);
  }

  checkVoteOptions() {
    var self = this,
      votesUp = $("#comments").find("[data-ajax-vote-up-number]"),
      votesDown = $("#comments").find("[data-ajax-vote-down-number]");

    if (parseInt(votesUp) > 0) {
      return false;
    } else if (parseInt(votesDown) > 0) {
      return false;
    } else {
      self.hideVoteOptions();
      return false;
    }
    this.element.on("change", function(e) {
      self.fetch();
    });
  }

  hideVoteOptions() {
    var self = this;
    $(this.element)
      .find("option")
      .each(function() {
        if (this.value == "liked") {
          $(this).prop("disabled", "disabled");
        } else if (this.value == "disliked") {
          $(this).prop("disabled", "disabled");
        }
      });
  }
}

export { CommentSort };



// WEBPACK FOOTER //
// ./Javascript/core/classes/comments/comments.sort.class.js